define(["require", "exports", "../Tenant"], function (require, exports, Tenant_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Content = (function () {
        function Content() {
            this.Type = null;
            this.Name = null;
            this.Comment = null;
            this.IsLocked = false;
            this.CreatedBy = null;
            this.LastChangeBy = "";
            this.IsDeleted = false;
            this.TenantId = null;
            this.Tenant = new Tenant_1.Tenant();
            this.AssignedLocations = [];
            this.SecurityInfo = new ContentSecurity();
        }
        Object.defineProperty(Content.prototype, "IsVideo", {
            get: function () { return false; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Content.prototype, "IsImage", {
            get: function () { return false; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Content.prototype, "IsWebSite", {
            get: function () { return false; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Content.prototype, "IsFreeText", {
            get: function () { return false; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Content.prototype, "IsStream", {
            get: function () { return false; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Content.prototype, "IsScheduler", {
            get: function () { return false; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Content.prototype, "IsPlayList", {
            get: function () { return false; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Content.prototype, "IsMultiScreen", {
            get: function () { return false; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Content.prototype, "IsSujet", {
            get: function () { return false; },
            enumerable: true,
            configurable: true
        });
        return Content;
    }());
    exports.Content = Content;
    var ContentSecurity = (function () {
        function ContentSecurity() {
            this.Level = 8;
            this.AllowedGroups = [];
            this.AllowedUsers = [];
        }
        return ContentSecurity;
    }());
    exports.ContentSecurity = ContentSecurity;
    var ContentTypes = (function () {
        function ContentTypes() {
        }
        ContentTypes.Asset = "asset";
        ContentTypes.Scheduler = "scheduler";
        ContentTypes.MultiScreen = "multiscreen";
        ContentTypes.Sujet = "sujet";
        ContentTypes.PlayList = "playlist";
        ContentTypes.undefined = "undefined";
        return ContentTypes;
    }());
    exports.ContentTypes = ContentTypes;
    var AssetTypes = (function () {
        function AssetTypes() {
        }
        AssetTypes.Undefined = "undefined";
        AssetTypes.Image = "image";
        AssetTypes.Website = "website";
        AssetTypes.Video = "video";
        AssetTypes.Stream = "stream";
        AssetTypes.TVChannel = "tvchannel";
        AssetTypes.FreeText = "freetext";
        return AssetTypes;
    }());
    exports.AssetTypes = AssetTypes;
    var JsonCreationConverter = (function () {
        function JsonCreationConverter() {
            this.CanWrite = false;
        }
        return JsonCreationConverter;
    }());
    exports.JsonCreationConverter = JsonCreationConverter;
});
//# sourceMappingURL=Content.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/Content/Content.js
// module id = 57
// module chunks = 0